export default class GroupMembershipModalController {
  public group: any;
  public owner: any;
  public account: any;
  private $close: any;

  static $inject = [];

  constructor() {}
}
